// Textos del avatar. Ya no recorre la página: se queda en su lugar, charla y hace una presentación.
//
// PRESENTATION: discurso corto, sin referencias a lo que hay en pantalla. Cada paso tiene un `id`; si existe
// public/audio/tour/<id>.mp3 (por ejemplo generado con tu voz clonada) se reproduce ese audio, y si no, la voz
// sintética del navegador. `gesture`: gesto en bucle mientras habla (talk_beat | talk_open).
// `cue`: gesto puntual al empezar (wave | point | hand_chest). Los textos salen de lo que ya dice el portafolio.
export const PRESENTATION = [
  {
    id: 'intro', cue: 'wave', gesture: 'talk_beat',
    text: '¡Hola! Soy Tincho, y este soy yo, en versión tres D. Soy desarrollador Full Stack e ingeniero en IoT y Robótica.',
  },
  {
    id: 'story', cue: 'hand_chest', gesture: 'talk_beat',
    text: 'Mi historia no empezó en una universidad, sino en un taller, reparando computadoras, motos y electrónica. Después me gradué en Robótica e IoT, di el salto al desarrollo web completo, y hoy sumo inteligencia artificial a todo lo que hago. Tengo más de tres años de experiencia y más de quince proyectos entregados.',
  },
  {
    id: 'services', gesture: 'talk_open',
    text: '¿Qué puedo hacer por vos? Desde una landing page hasta una plataforma completa, con pagos y panel de administración. También sistemas IoT, inteligencia artificial que de verdad conoce tu negocio, puesta en la nube, aplicaciones móviles, y talleres de programación y robótica.',
  },
  {
    id: 'process', gesture: 'talk_beat',
    text: 'Y no improviso. Primero entiendo tu negocio, después diseño la arquitectura, desarrollo con entregas frecuentes, pruebo todo, lo publico en la nube, y sigo acompañándote después del lanzamiento.',
  },
  {
    id: 'akira', cue: 'point', gesture: 'talk_beat',
    text: 'Mi proyecto favorito es Akira, una alarma inteligente para motos, con ESP32, sensores, GPS y una app en el celular. Hardware, software e inteligencia artificial en un solo producto.',
  },
  {
    id: 'contact', cue: 'wave', gesture: 'talk_open',
    text: 'Si tenés una idea, un negocio o un problema para resolver, escribime. Respondo en menos de veinticuatro horas. ¡Gracias por pasar, y charlemos cuando quieras!',
  },
];

export const GREETING = '¡Hola! Soy Tincho 👋 Podés charlar conmigo, hacerme clic o pedirme que haga algo.';

/** Reacciones cuando le hacés clic al avatar (gesto + frase). */
export const REACTIONS = [
  { cue: 'wave', text: '¡Ey! ¿Cómo andás? 👋' },
  { cue: 'nod_yes', text: '¡Presente! Preguntame lo que quieras.' },
  { cue: 'shrug', text: 'No sé qué esperabas… ¡pero acá estoy! 😄' },
  { cue: 'point', text: 'Probá preguntarme por mis servicios 👉' },
  { cue: 'shake_no', text: '¡Cosquillas no, por favor! 😂' },
  { cue: 'hand_chest', text: 'Soy un avatar, pero con muy buen humor.' },
];

/** Gestos que se pueden pedir con los botones. */
export const EMOTES = [
  { cue: 'wave', icon: '👋', label: 'Saludar' },
  { cue: 'nod_yes', icon: '👍', label: 'Asentir' },
  { cue: 'shake_no', icon: '🙅', label: 'Negar' },
  { cue: 'shrug', icon: '🤷', label: 'Encogerse de hombros' },
  { cue: 'point', icon: '👉', label: 'Señalar' },
];
